// @core/api/endpoints/calendar/remove_attendee.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Remove attendee
 * Removes an attendee from the event. The removed attendee is notified of their removal.
 */
export async function RemoveAttendee(
  event_id: string,
  attendee_id: string,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/attendees/:attendee_id`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  requestPath = requestPath.replace(':attendee_id', encodeURIComponent(attendee_id));
  const requestOptions = options;
  return client.delete<EventResponse>(requestPath, requestOptions);
}
